import {CONFIG} from "../../config";
import axios from "axios";

async function AddApiKeyQuery(device_id) {
    const data = {
        'device_id': device_id
    }

    const location = CONFIG.API_URL + "api-key/add";
    const settings = {
        headers: {
            'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('bearer-token')}`,
        }
    };
    try {
        return await axios.post(location, data, settings);
    } catch (e) {
        return e;
    }
}

export default AddApiKeyQuery;